import styled, { css } from 'styled-components'
import { Row } from '../../atoms/GridSystem'
import { Icon as StyledIcon } from '../../atoms/Icon/Icon.styles'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'

interface LineProps {
  theme: any
}

interface TextColumnsIllustrationProps {
  theme: any
}

interface TextQuoteWrapperProps {
  theme: any
  colorScheme: string
  withBackground?: boolean
}

interface TextProps {
  theme: any
  removeBottomPadding?: boolean
  colorScheme?: string
  variant?: string
  withBackground?: boolean
}

interface RowTextHeadingProps {
  alignment?: 'left' | 'center'
}

interface TextWithImageMaskProps {
  maskType?: string
}

export const Line = styled.div<LineProps>`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.rem(24)};
  border-top: 1px solid;

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-bottom: ${theme.rem(24)};
  `)}
`

export const TextColumnsIllustration = styled.div<TextColumnsIllustrationProps>`
  width: 100%;
  min-height: ${({ theme }) => theme.rem(410)};
  display: flex;
  align-items: center;
  justify-content: center;

  svg,
  ${StyledIcon} {
    width: 100%;
    height: 100%;
  }
`

export const TextQuoteWrapper = styled.div<TextQuoteWrapperProps>`
  margin: ${({ theme }) => theme.rem(24, 0)};

  ${({ theme }) => theme.mediaQuery.xl(`
    margin: ${theme.rem(40, 0)};
  `)}
`

export const Text = styled.div<TextProps>`
  // padding-top: ${({ theme }) => theme.rem(24)};

  // ${({ theme }) => theme.mediaQuery.lg(`
  //   padding-top: ${theme.rem(40)};
  // `)}

  // ${({ theme, removeBottomPadding }) => removeBottomPadding !== true && css`
  //   padding-bottom: ${theme.rem(24)};

  //   ${theme.mediaQuery.lg(`
  //     padding-bottom: ${theme.rem(40)};
  //   `)}
  // `}

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }

  ${TextColumnsIllustration} {
    svg {
      color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.colorIcon};
    }
  } 
`

export const RowTextHeading = styled(Row)<RowTextHeadingProps>`
  ${({ alignment }) => alignment && css`
    text-align: ${alignment};
  `}
`

export const TextWithImageMask = styled.div<TextWithImageMaskProps>`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 4;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.rem(4)};

  ${({ maskType }) => maskType && css`
    mask-image: url('/masks/mask-${maskType}.svg');
    mask-size: 100%;
    mask-repeat: no-repeat;
    mask-position: center;
  `}

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const TextQuoteInner = styled.div<TextQuoteWrapperProps>`
  border-radius: ${({ theme }) => theme.rem(24)};
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.inside};
  color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
  padding: ${({ theme }) => theme.rem(24)};
  border-radius: ${({ theme }) => theme.rem(24)};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
  }

  ${({ theme }) => theme.mediaQuery.md(`
    padding: ${theme.rem(80, 24)};
  `)}

  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(80, 40)};
  `)}

  i {
    font-size: ${({ theme }) => theme.rem(42)};
  }
`

export const TextQuoteBottom = styled.div`
  padding: ${({ theme }) => theme.rem(16)};
  
  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(24)};
  `)};
`

export const TextLeafWrapper = styled.div`
  i {
    font-size: ${({ theme }) => theme.rem(16)};
  }
`

export const TextQuoteAuthor = styled.div<{ colorScheme: string, withBackground: boolean }>`
  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`